import React, { type FC, type MouseEvent } from 'react';
import { MenuGroupMinWidth } from '@jira/navigation-apps__constants/src/MenuGroupMinWidth.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import type { ContentProps } from '@atlaskit/popup/types';
import { Box } from '@atlaskit/primitives/compiled/box';
import type { MenuItemsComponentType } from '../../types.tsx';

type MenuContentProps = Partial<ContentProps> & {
	MenuItems: MenuItemsComponentType;
};

const stopEventPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

export const MenuContent: FC<MenuContentProps> = ({ MenuItems, onClose }) => (
	<Box onMouseEnter={stopEventPropagation} onMouseLeave={stopEventPropagation}>
		<MenuGroup minWidth={MenuGroupMinWidth}>
			<MenuItems onClose={onClose} />
		</MenuGroup>
	</Box>
);
